'use strict';

/* const tabsWithContent = () => {
	let tabs = document.querySelectorAll('#tabbed-content .tabs li');
	if (tabs.length === 0) {
		return;
	}
	let tabsContent = document.querySelectorAll('.tab-content');

	let deactivateAllTabs = function () {
		tabs.forEach(function (tab) {
			tab.classList.remove('is-active');
		});
	};

	let hideTabsContent = function () {
		tabsContent.forEach(function (tabContent) {
			tabContent.classList.remove('is-active');
		});
	};

	let activateTabsContent = function (tab) {
		tabsContent[getIndex(tab)].classList.add('is-active');
	};

	let getIndex = function (el) {
		return [...el.parentElement.children].indexOf(el);
	};

	tabs.forEach(function (tab) {
		tab.addEventListener('click', function () {
			deactivateAllTabs();
			hideTabsContent();
			tab.classList.add('is-active');
			activateTabsContent(tab);
		});
	});

	tabs[0].click();
};

tabsWithContent(); */


const { createApp } = window.Vue;

createApp({
	setup() {
		const removeActiveClass = (tabs, tabsContent) => {
			Array.from(tabs).forEach(item => {
				item.classList.remove('is-active');
			});

			Array.from(tabsContent).forEach(item => {
				item.classList.remove('is-active');
			});
		};

		const showTabContent = target => {
			document.getElementById(target).classList.add('is-active');
		};

		const tabClick = (e) => {
			const tabs = document.querySelectorAll('.tabs__link');
			const tabsContent = document.querySelectorAll('.tabs-content__item');
			const tab = e.target.closest('.tabs__link');
			const dataTarget = tab.getAttribute('data-target');

			e.preventDefault();

			removeActiveClass(tabs, tabsContent);

			tab.classList.add('is-active');
			showTabContent(dataTarget);
		};

		const showFirstTab = () => {
			const firstTab = document.querySelectorAll('.tabs__link')[0];

			firstTab.click();
		};

		return { tabClick, showFirstTab };
	},
	mounted() {
		this.showFirstTab();
	}
}).mount('#app');